'use client'

import { ToastBar, Toaster } from 'react-hot-toast'
import { Typography } from '@repo/design-system-cf/components/typography'
import { IconWarning, IconCheckCircle } from '@repo/design-system-cf/components/icons'
import { useBreakpoint } from '@repo/web-ui/hooks/use-breakpoints'

export function SocialToaster() {
  const { breakpoint } = useBreakpoint()
  const isMobile = ['xs', 'sm'].includes(breakpoint ?? '')
  const topPosition = isMobile ? 40 : 100
  return (
    <div className="relative h-px">
      <Toaster
        position="top-right"
        containerStyle={{
          position: 'fixed',
          top: topPosition,
        }}
        toastOptions={{
          success: {
            style: {
              borderLeft: '8px solid #0F7B59',
              backgroundColor: '#EFFAF8',
              margin: 0,
              paddingTop: 12,
              paddingRight: 28,
              paddingBottom: 12,
            },
          },
          error: {
            style: { borderLeft: '8px solid #B5162D', backgroundColor: '#FCE7EA', margin: 0 },
          },
        }}
      >
        {t => (
          <ToastBar
            toast={t}
            style={{
              ...t.style,
              animation: t.visible
                ? 'enterFromRight 300ms ease-out forwards'
                : 'exitToRight 300ms ease-in forwards',
            }}
          >
            {({ message }) => (
              <div className="flex justify-start items-start w-full h-full">
                {t.type === 'error' ? <IconWarning className="text-cf-red-600 size-4 " /> : null}
                {t.type === 'success' ? (
                  <IconCheckCircle className="text-[#0F7B59] size-4 mt-2" />
                ) : null}

                <Typography className="text-14 font-semibold text-cf-grey-1000">
                  {message}
                </Typography>
              </div>
            )}
          </ToastBar>
        )}
      </Toaster>
    </div>
  )
}
